<template>
    <div class="wang-editor">
        <div :id="domId" class="wangEditor-txt"></div>
        <!-- 预览 -->
        <div v-show="isShowPreviewBox" class="editor-preview question-content markdown-body">
            <div class="question-desc" v-html="editorValue"></div>
        </div>
        <p class="fullScreen-tips" v-if="isShowTips">
            按<span>ESC</span>键 可以快速退出全屏
        </p>
    </div>
</template>

<script>
    import wangeditor from 'wangeditor';
    export default {
        props: {
            questionValue: {
                type: String,
                default: ''
            },
            domId: {
                type: String,
                default: 'myEditor'
            },
            parentId: {
                type: Number,
                default: 0
            },
            isPreview: {
                type: Boolean,
                default: false
            },
            isMarkDown: {
                type: Boolean,
                default: false
            },
            isFullScreen: {
                type: Boolean,
                default: false
            }
        },
        mounted() {
            this.initEditor();
        },
        data () {
            return {
                isInit: true,
                isShowPreviewBox: false,
                editorValue: null,
                isShowTips: false,
                enlarge: require('@/images/community/full-screen.png'),
                shrink: require('@/images/community/un-full-screen.png'),
                preview: require('@/images/community/preview.png'),
                unPreview: require('@/images/community/un-preview.png'),
                editor: null
            }
        },
        watch: {
            isMarkDown (val) {
                if (val) {
                    const previewDom = $('.is-preview')
                    if (previewDom && this.isShowPreviewBox) {
                        previewDom.click()
                    }
                    this.isInit = true
                }
            },
            questionValue (val) {
                if (!val) {
                    this.editor.txt.html('');
                }

                if (this.isInit) {
                    this.isInit = this.isMarkDown
                    const filterVal = this.filterXSS(val)
                    this.editorValue = filterVal
                    this.editor.txt.html(filterVal)
                }
            }
        },
        computed: {
            editorEle () {
                if (document.querySelector(`#${this.domId}`)) {
                    return document.querySelector(`#${this.domId}`)
                }
            }
        },
        methods: {
            initEditor() {
                let _self = this;
                this.editor = new wangeditor(`#${this.domId}`);
                this.initEditorConfig(); // 初始化编辑器配置，在create之前
                this.editor.customConfig.menus = [
                    'head',  // 标题
                    'bold',  // 粗体
                    'fontSize',  // 字号
                    'fontName',  // 字体
                    'italic',  // 斜体
                    'underline',  // 下划线
                    'strikeThrough',  // 删除线
                    'link',  // 插入链接
                    'list',  // 列表
                    'justify',  // 对齐方式
                    'quote',  // 引用
                    'emoticon',  // 表情
                    'image',  // 插入图片
                    'table',  // 表格
                    'code',  // 插入代码
                    'undo',  // 撤销
                    'redo'  // 重复
                ];
                // 用户操作回调
                const urlRegexp = /[^="](https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|;]/ig // 不以 =" 开头的所有链接
                const aRegExp = /<a[^\>]*?>(.*?)<\/a>/ig
                this.editor.customConfig.onchange = function (val) {
                    _self.isInit = false // 操作时不需要对编辑器进行赋值操作
                    let content = val
                    if (val.search(urlRegexp) > -1) {
                        if (content.search(aRegExp) > -1) {
                            content = content.replace(aRegExp, ($, $1) => {
                                return $1.search(urlRegexp) > -1 ? $1 : $
                            })
                        }
                        if (content.search(urlRegexp) > -1) {
                            content = content.replace(urlRegexp, $ => {
                                const prevText = $[0] || ''
                                const link = $.slice(1)
                                let href = link
                                let nextText = ''
                                if (link.search('&nbsp;') > -1) {
                                    href = link.split('&nbsp;')[0]
                                    nextText = link.split('&nbsp;').slice(1).join('')
                                }
                                return `${prevText}<a href="${href}" target="_blank">${href}</a>${nextText}`
                            })
                        }
                    }
                    _self.editorValue = content
                    _self.$emit('onChangeEditor', content, _self.domId, _self.parentId)
                }
                this.editor.customConfig.onchangeTimeout = 200 // 修改为 500ms
                this.editor.create(); // 生成编辑器
                // 初始化预览
                if (this.isPreview) {
                    this.initPreview()
                }
                // 初始化全屏预览
                if (this.isFullScreen) {
                    this.initFullscreen()
                }
                $(`#${this.domId}`).attr('style', 'height:auto;');
                this.editor.txt.html(this.questionValue);
            },
            // 自定义上传参数配置
            initEditorConfig() {
                this.editor.customConfig.uploadImgServer = myUrl + 'forum/upload_file/markdown/image/';
                this.editor.customConfig.uploadFileName = 'upload_image';
                this.editor.customConfig.withCredentials = true;
                this.editor.customConfig.showLinkImg  = false;
                this.editor.customConfig.uploadImgHooks = {
                    success: function (xhr, editor, result) {}
                }
            },
            // 初始化全屏预览
            initFullscreen () {
                let isFullscreen = false
                let fullscreenBtn = this.createBtn(this.enlarge, 'is-fullscreen')
                const toolbar = document.querySelector(`#${this.domId} .w-e-toolbar`)
                toolbar.appendChild(fullscreenBtn)
                fullscreenBtn.addEventListener('click', _ => {
                    this.editorEle.className = isFullscreen ? 'wangEditor-txt' : 'wangEditor-txt fullscreen-editor'
                    fullscreenBtn.src = isFullscreen ? this.enlarge : this.shrink
                    isFullscreen = !isFullscreen
                    // 支持esc按键返回
                    if (isFullscreen) {
                        window.addEventListener('keyup', e => {
                            if (e.keyCode === 27) {
                                this.editorEle.className = 'wangEditor-txt'
                                fullscreenBtn.src = this.enlarge
                                isFullscreen = !isFullscreen
                            }
                        })
                        this.isShowTips = true
                        setTimeout(() => {
                            this.isShowTips = false
                        }, 2500)
                    }
                }, false)
            },
            // 初始化预览
            initPreview () {
                let isPreview = false
                let previewBtn = this.createBtn(this.preview, 'is-preview')
                const toolbar = document.querySelector(`#${this.domId} .w-e-toolbar`)
                toolbar.appendChild(previewBtn)
                previewBtn.addEventListener('click', _ => {
                    const className = this.editorEle.className
                    this.editorEle.className = isPreview ? className : (className + ' preview-editor')
                    previewBtn.src = isPreview ? this.preview : this.unPreview
                    isPreview = !isPreview
                    this.isShowPreviewBox = isPreview
                }, false)
            },
            createBtn (imgUrl, className) {
                let btn = document.createElement('img')
                btn.className = `w-e-menu ${className}`
                btn.style.zIndex = '100'
                btn.src = imgUrl
                return btn
            }
        }
    }
</script>

<style lang="scss">
    // 富文本样式
    .wang-editor {
        position: relative;
        .wangEditor-txt{
            height: 100% !important;
            display: flex;
            flex-direction: column;
            .w-e-toolbar {
                border-color: #dcdee5 !important;
                background: #fff !important;
                position: relative;
                .w-e-menu {
                    z-index: 1000 !important;
                    i {
                        color: #757575;
                        font-weight: 500;
                    }
                }
                .is-preview {
                    position: relative;
                    top: 12px;
                    height: 20px;
                    width: 20px;
                    padding: 0;
                    margin: 0 10px;
                }
                .is-fullscreen {
                    position: absolute;
                    right: 10px;
                    top: 8px;
                    height: 22px;
                    width: 32px;
                }
            }
            .w-e-text-container {
                flex: 1;
                border-color: #dcdee5 !important;
                z-index: 999 !important;
                .w-e-text {
                    overflow: auto;
                    min-height: 454px;
                    &::-webkit-scrollbar {
                        width: 0;
                    }
                    p, span, a {
                        font-size: 14px !important;
                    }
                    img {
                        max-width: 500px;
                    }
                }
            }
        }
        // 预览
        .editor-preview {
            width: 100%;
            height: 454px;
            padding: 10px 0;
            position: absolute;
            z-index: 10002;
            top: 46px;
            left: 1px;
            background: #fff;
            overflow-y: auto;
            font-size: 14px;
            .question-desc {
                line-height: 24px;
                color: #4f515e;
                border-bottom: none !important;
                p{
                    img{
                        width: 100%;
                    }
                }
            }
        }
        .fullscreen-editor {
            position: fixed !important;
            width: 100% !important;
            height: 100% !important;
            left: 0px !important;
            top: 0px !important;
            background-color: white;
            z-index: 100001;
        }
        .fullscreen-editor .w-e-toolbar {
            background: #f0f1f5 !important;
            padding: 0 100px;
        }
        .fullscreen-editor .w-e-text-container {
            width: 100% !important;
            height: 95% !important;
            padding: 0 100px;
        }
    }
</style>



// WEBPACK FOOTER //
// wangEditor.vue?08af1980